/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgChessPawn = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M12 2a4 4 0 0 1 3.002 6.642c.047 3.576 1.883 6.274 3.31 7.374A3 3 0 0 1 21 19v3H3v-3a3 3 0 0 1 2.816-2.994c1.382-1.103 3.136-3.79 3.181-7.364A4 4 0 0 1 12 2zM6 18a1 1 0 0 0-1 1v1h14v-1a1 1 0 0 0-1-1zm7.073-8.147a4 4 0 0 1-2.144 0C10.666 12.368 9.7 14.49 8.562 16h6.954c-1.169-1.508-2.17-3.63-2.443-6.147zM12 4a2 2 0 1 0 0 4 2 2 0 0 0 0-4z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgChessPawn as ChessPawn };
